import {
  Button,
  IconText,
  Image,
  ModalLayout,
} from "@wac-ui-dashboard/wac_component_library";
import Style from "../programmeUpdationForm.module.scss";
import { limitStrLength } from "../../../../utils/functions/table";
import { SelectFromThumbnails } from "../../../MenuThumbnails/ThumbnailPicker";
import useUploads from "./useUploads";
import { ProfileCard } from "../../../Global/ProfileCard";

const Uploads = ({
  formik,
  getFieldError,
  isEditData,
  isLoading,
  profilefileInputRef,
  handleImage,
  imagePreview,
  show,
  closeModal,
  fieldName,
  setShow,
  setImagePreview,
  cropData,
  formikImage,
  setFormikImage,
  handleTitleImage,
  imageTitleImagePreview,
  setImageTitleImagePreview,
  imageVerticalThumbnailPreview,
  handleClick,
  imageBannerPreview,
  setImageBannerPreview,
  handleBannerImage,
  imageCoverPreview,
  handleThumbnail,
  setImageCoverPreview,
  setImageVerticalThumbnailPreview,
  handleVerticalImage
}) => {
  const { handleCloseModal } = useUploads({
    formik,
  });

  return (
    <div className={`pro-w-100`}>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          Basic Thumbnail [1:1]*
        </label>
        <div className="input-drag">
          <input
            type="file"
            placeholder="placeholder"
            accept=".jpeg, .jpg , .png, .gif"
            ref={profilefileInputRef}
            className={`pro-input lg ${getFieldError("image") && " error"}`}
            id="image"
            name="image"
            onBlur={formik.handleBlur("image")}
            onChange={(e) => handleImage(e)}
            onClick={handleClick}
          />
          <span className="input-drag-box">
            <IconText
              title={
                formik?.values?.image?.name !== undefined &&
                isEditData &&
                formik?.values?.image?.name
                  ? limitStrLength(formik?.values?.image?.name, 30)
                  : isEditData && formik?.values?.image
                  ? limitStrLength(formik?.values?.image ?? "", 30)
                  : !isEditData && formik?.values?.image?.name
                  ? limitStrLength(formik?.values?.image?.name ?? "", 30)
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {getFieldError("image") && (
            <span className="error-text">{getFieldError("image")}</span>
          )}
        </div>
        <p className="pro-mb-0 pro-font-xs pro-mt-1">
          (file of type: jpeg, png, jpg, gif.)
        </p>
        {/* pick an image from Menu Thumbnails instead of uploading one */}
        <SelectFromThumbnails
          mediaType="program"
          ratio={{ width: 1, height: 1 }}
          label="Basic Thumbnail"
          fieldName="image"
          formik={formik}
          setPreview={setImagePreview}
        />
      </div>
      <div className={`col-2 pro-my-2`}>
        <div className={`${Style.root_image_inner}`}>
          <Image
            width={100}
            height={100}
            src={imagePreview}
            alt={`image - 01`}
          />
        </div>
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          Title Image [3:2]*
        </label>
        <div className="input-drag">
          <input
            type="file"
            placeholder="placeholder"
            accept=".png"
            ref={profilefileInputRef}
            className={`pro-input lg ${
              getFieldError("title_image") && " error"
            }`}
            id="title_image"
            name="title_image"
            onBlur={formik.handleBlur("title_image")}
            onChange={(e) => handleTitleImage(e)}
            onClick={handleClick}
          />
          <span className="input-drag-box">
            <IconText
              title={
                formik?.values?.title_image?.name !== undefined &&
                isEditData &&
                formik?.values?.title_image?.name
                  ? limitStrLength(formik?.values?.title_image?.name, 30)
                  : isEditData && formik?.values?.title_image
                  ? limitStrLength(formik?.values?.title_image ?? "", 30)
                  : !isEditData && formik?.values?.title_image?.name
                  ? limitStrLength(formik?.values?.title_image?.name ?? "", 30)
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {getFieldError("title_image") && (
            <span className="error-text">{getFieldError("title_image")}</span>
          )}
        </div>
        <p className="pro-mb-0 pro-font-xs pro-mt-1">(file of type: png.)</p>
        {/* pick an image from Menu Thumbnails instead of uploading one */}
        <SelectFromThumbnails
          mediaType="program"
          ratio={{ width: 3, height: 2 }}
          label="Title Image"
          fieldName="title_image"
          formik={formik}
          setPreview={setImageTitleImagePreview}
        />
      </div>
      <div className={`col-2 pro-my-2`}>
        <div className={`${Style.root_image_inner}`}>
          <Image
            width={100}
            height={100}
            src={imageTitleImagePreview}
            alt={`title_image`}
          />
        </div>
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          List Thumbnail [2:3]*
        </label>
        <div className="input-drag">
          <input
            type="file"
            placeholder="placeholder"
            accept=".jpeg, .jpg , .png"
            ref={profilefileInputRef}
            className={`pro-input lg ${
              getFieldError("list_thumbnail") && " error"
            }`}
            id="list_thumbnail"
            name="list_thumbnail"
            onBlur={formik.handleBlur("list_thumbnail")}
            onChange={(e) => handleThumbnail(e)}
            onClick={handleClick}
          />
          <span className="input-drag-box">
            <IconText
              title={
                formik?.values?.list_thumbnail?.name !== undefined &&
                isEditData &&
                formik?.values?.list_thumbnail?.name
                  ? limitStrLength(formik?.values?.list_thumbnail?.name, 30)
                  : isEditData
                  ? limitStrLength(formik?.values?.list_thumbnail ?? "", 30)
                  : !isEditData && formik?.values?.list_thumbnail?.name
                  ? limitStrLength(
                      formik?.values?.list_thumbnail?.name ?? "",
                      30
                    )
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {getFieldError("list_thumbnail") && (
            <span className="error-text">
              {getFieldError("list_thumbnail")}
            </span>
          )}
        </div>
        <p className="pro-mb-0 pro-font-xs  pro-mt-1">
          (file of type: jpeg, png, jpg, gif.)
        </p>
        {/* pick an image from Menu Thumbnails instead of uploading one */}
        <SelectFromThumbnails
          mediaType="program"
          ratio={{ width: 2, height: 3 }}
          label="List Thumbnail"
          fieldName="list_thumbnail"
          formik={formik}
          setPreview={setImageCoverPreview}
        />
      </div>
      <div className={`col-2 pro-my-2`}>
        <div className={`${Style.root_image_inner}`}>
          <Image
            width={100}
            height={100}
            src={imageCoverPreview}
            alt={`list_thumbnail`}
          />
        </div>
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          Banner Image [4:5]*
        </label>
        <div className="input-drag">
          <input
            type="file"
            placeholder="placeholder"
            accept=".jpeg, .jpg , .png, .gif"
            className={`pro-input lg ${
              getFieldError("banner_image") && " error"
            }`}
            id="banner_image"
            name="banner_image"
            onBlur={formik.handleBlur("banner_image")}
            onChange={(e) => handleBannerImage(e)}
            onClick={handleClick}
          />
          <span className="input-drag-box">
            <IconText
              title={
                formik?.values?.banner_image?.name !== undefined &&
                isEditData &&
                formik?.values?.banner_image?.name
                  ? limitStrLength(formik?.values?.banner_image?.name, 30)
                  : isEditData && formik?.values?.banner_image
                  ? limitStrLength(formik?.values?.banner_image ?? "", 30)
                  : !isEditData && formik?.values?.banner_image?.name
                  ? limitStrLength(formik?.values?.banner_image?.name ?? "", 30)
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {getFieldError("banner_image") && (
            <span className="error-text">{getFieldError("banner_image")}</span>
          )}
        </div>
        <p className="pro-mb-0 pro-font-xs pro-mt-1">
          (file of type: jpeg, png, jpg, gif.)
        </p>
        {/* pick an image from Menu Thumbnails instead of uploading one */}
        <SelectFromThumbnails
          mediaType="program"
          ratio={{ width: 4, height: 5 }}
          label="Banner Image"
          fieldName="banner_image"
          formik={formik}
          setPreview={setImageBannerPreview}
        />
      </div>
      <div className={`col-2 pro-my-2`}>
        <div className={`${Style.root_image_inner}`}>
          <Image
            width={50}
            height={50}
            src={imageBannerPreview}
            alt={`banner_image`}
          />
        </div>
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          Vertical Thumbnail [3:4]*
        </label>
        <div className="input-drag">
          <input
            type="file"
            placeholder="placeholder"
            ref={profilefileInputRef}
            className={`pro-input lg ${
              getFieldError("vertical_thumbnail") && " error"
            }`}
            id="vertical_thumbnail"
            name="vertical_thumbnail"
            onBlur={formik.handleBlur("vertical_thumbnail")}
            onChange={(e) => handleVerticalImage(e)}
            onClick={handleClick}
          />
          <span className="input-drag-box">
            <IconText
              title={
                formik?.values?.vertical_thumbnail?.name ||
                (formik?.values?.vertical_thumbnail?.[0]?.name !== undefined &&
                  isEditData &&
                  formik?.values?.vertical_thumbnail?.name) ||
                formik?.values?.vertical_thumbnail?.[0]?.name
                  ? limitStrLength(
                      formik?.values?.vertical_thumbnail?.name ||
                        formik?.values?.vertical_thumbnail?.[0]?.name,
                      30
                    )
                  : isEditData && formik?.values?.vertical_thumbnail
                  ? limitStrLength(formik?.values?.vertical_thumbnail ?? "", 30)
                  : (!isEditData && formik?.values?.vertical_thumbnail?.name) ||
                    formik?.values?.vertical_thumbnail?.[0]?.name
                  ? limitStrLength(
                      (formik?.values?.vertical_thumbnail?.name ||
                        formik?.values?.vertical_thumbnail?.[0]?.name) ??
                        "",
                      30
                    )
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {getFieldError("vertical_thumbnail") && (
            <span className="error-text">{getFieldError("vertical_thumbnail")}</span>
          )}
        </div>
        <p className="pro-mb-0 pro-font-xs pro-mt-1">(file of type: jpeg, png, jpg, gif.)</p>
        {/* pick an image from Menu Thumbnails instead of uploading one */}
        <SelectFromThumbnails
          mediaType="program"
          ratio={{ width: 3, height: 4 }}
          label="Vertical Thumbnail"
          fieldName="vertical_thumbnail"
          formik={formik}
          setPreview={setImageVerticalThumbnailPreview}
        />
      </div>
      <div className={`col-2 pro-my-2`}>
        <div className={`${Style.root_image_inner}`}>
          <Image
            width={100}
            height={100}
            src={imageVerticalThumbnailPreview}
            alt={`vertical_thumbnail`}
          />
        </div>
      </div>

      {formikImage && (
        <ModalLayout backdrop="static" show={show} handleClose={closeModal}>
          <ProfileCard
            setShow={setShow}
            fieldName={fieldName}
            formik={formik}
            data={formikImage}
            handleClose={closeModal}
            setImagePreview={setImagePreview}
            setImageTitleImagePreview={setImageTitleImagePreview}
            setImageBannerPreview={setImageBannerPreview}
            setImageVerticalThumbnailPreview={setImageVerticalThumbnailPreview}
            setImageCoverPreview={setImageCoverPreview}
            cropData={cropData}
            setFormikImage={setFormikImage}
          />
        </ModalLayout>
      )}

      <div className="col-12 pro-mt-4 pro-d-flex pro-justify-end">
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={() => handleCloseModal()}
          type="button"
        >
          Cancel
        </Button>

        <Button
          className={"pro-btn-primary lg pro-mx-3"}
          type="submit"
          disabled={isLoading}
        >
          {isEditData ? "Update" : "Create"}
        </Button>
      </div>
    </div>
  );
};
export default Uploads;
